import EntryActionTypes from '../../constants/EntryActionTypes';

export const createProtocol = (data) => ({
  type: EntryActionTypes.PROTOCOL_CREATE,
  payload: {
    data,
  },
});

export const updateProtocol = (id, data) => ({
  type: EntryActionTypes.PROTOCOL_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteProtocol = (id) => ({
  type: EntryActionTypes.PROTOCOL_DELETE,
  payload: {
    id,
  },
});

export const updateCurrentProtocol = (data) => ({
  type: EntryActionTypes.CURRENT_PROTOCOL_UPDATE,
  payload: {
    data,
  },
});

export const deleteCurrentProtocol = () => ({
  type: EntryActionTypes.CURRENT_PROTOCOL_DELETE,
  payload: {},
});
